import { render, staticRenderFns } from "./tm_Name.vue?vue&type=template&id=5f547d86&scoped=true"
import script from "./tm_Name.vue?vue&type=script&lang=js"
export * from "./tm_Name.vue?vue&type=script&lang=js"
import style0 from "./tm_Name.vue?vue&type=style&index=0&id=5f547d86&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f547d86",
  null
  
)

export default component.exports